import { useContext, useEffect, useState } from "react";
import { supportConfig } from "../../../../configs/supportConfig";
import { SettingsContext } from "../../../../contexts/SettingsContext";

import AddUserModal from "./overlay/addUserModal";
import { Button, ButtonRow, Heading, Pagination, TabRow, TabRowItem, Treegrid } from "cai-fusion";
import env from "../../../../configs/envConfig";

const searchIcon = require("../../../../images/search-icon-light.png");

const AccessControl = () => {

    const {
		licensedUsers,
		remainingLicenses,
		deprovisionLicense,
		unusableUsers,
		isLicensedEnvironment,
		tryFixUser,
		isLoadingUnusables,
	} = useContext(SettingsContext);

	const [filterValue, setFilterValue] = useState("");
	const [mode, setMode] = useState("all");
	const [currentPage, setCurrentPage] = useState(1);
	const [displayedUsers, setDisplayedUsers] = useState([]);
	const [addUsersIsHidden, setAddUsersIsHidden] = useState(true);

    const NUM_PER_PAGE = 10;

    const handleFilterChange = (e) => {
		const newVal = e.target.value.toLowerCase();

		setFilterValue(newVal);
		setCurrentPage(1);

		if (newVal === "") {
			setDisplayedUsers(licensedUsers);
		} else {
			setDisplayedUsers(licensedUsers.filter((u) => u.searchFields.some((f) => f.includes(newVal))));
		}
	};

	const getInTouch = (e) => {
		const bugReportLink = `mailto:${supportConfig.licensingContact}?subject=${env.REACT_APP_BRANDING_SYMPHONY_NAME ?? "Maestro"}%20Licensing`;
		window.location.href = bugReportLink;
		e.preventDefault();
	};

    useEffect(() => {
		if (mode === "all") {
			setDisplayedUsers(licensedUsers);
		} else {
			setDisplayedUsers(unusableUsers);
		}
	}, [licensedUsers, unusableUsers, mode]);

    return (
        <>
            <div className="row l-mt-sm">
                <div className="col-md-6">
                    <Heading size={3}>License Management</Heading>
                    <p className="a-muted-text">Manage which users have access to {env.REACT_APP_BRANDING_SYMPHONY_NAME ?? "Maestro"}.</p>
                </div>
                <div className="col-md-6">
                    <ButtonRow>
                        <Button 
                            children="Add User"
                            onClick={(e) => {
                                e.preventDefault();
                                setAddUsersIsHidden(false);
                            }}
                        />
                    </ButtonRow>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    {remainingLicenses === 0 &&
                        <div className="m-callout m-callout--shaded l-mb-sm">
                            <svg
                                className="m-callout__icon"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 358.38"
                            >
                                <g id="Layer_2">
                                    <g id="Engine_Warning">
                                        <path d="M38.4,179.19c-.01-47.52,15.54-93.74,44.29-131.58,4.24-5.33,3.52-13.06-1.64-17.51l-9.73-8.35c-5.39-4.66-13.54-4.06-18.2,1.33-.11,.13-.23,.27-.34,.41-70.38,91.86-70.38,219.52,0,311.38,4.41,5.56,12.49,6.5,18.05,2.1,.15-.12,.29-.23,.43-.36l9.78-8.35c5.12-4.45,5.84-12.14,1.64-17.46-28.74-37.86-44.29-84.09-44.28-131.63ZM255.99,0C157.03,0,76.8,80.23,76.8,179.19s80.23,179.19,179.19,179.19,179.19-80.23,179.19-179.19S354.95,0,255.99,0h0Zm0,281.58c-14.14,0-25.6-11.46-25.6-25.6s11.46-25.6,25.6-25.6,25.6,11.46,25.6,25.6-11.46,25.6-25.6,25.6Zm20.48-88.31c-.66,6.58-6.23,11.58-12.85,11.52h-15.36c-6.58,0-12.09-4.97-12.75-11.52l-10.24-102.39c-.68-7.06,4.5-13.34,11.56-14.02,.43-.04,.86-.06,1.29-.06h35.84c7.1,.02,12.83,5.8,12.81,12.89,0,.4-.02,.79-.06,1.18l-10.24,102.39ZM458.17,22.17c-4.45-5.57-12.57-6.47-18.13-2.02-.14,.11-.27,.22-.4,.33l-9.57,8.5c-5.11,4.5-5.76,12.22-1.48,17.51,60.21,78.24,60.21,187.21,0,265.46-4.28,5.29-3.62,13.01,1.48,17.51l9.57,8.45c5.36,4.7,13.51,4.16,18.21-1.2,.11-.13,.22-.26,.33-.39,71.78-92.39,71.78-221.7,0-314.09v-.05Z"></path>
                                    </g>
                                </g>
                            </svg>
                            <div className="m-callout__content">
                                <h4 className="m-callout__title">You've allocated all of your {env.REACT_APP_BRANDING_SYMPHONY_NAME ?? "Maestro"} licenses.</h4>
                                <p className="m-callout__text a-muted-text">Please contact your CAI representative to add additional users.</p>
                            </div>
                            <div className="m-callout__action">
                                <ButtonRow>
                                    <Button 
                                        onClick={getInTouch}
                                        children="Get in Touch"
                                    />
                                </ButtonRow>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <form className="a-search-input l-mb-xs">
                        <input
                            value={filterValue}
                            className="a-search-input__text-box"
                            type="text"
                            placeholder="Search users..."
                            aria-label="Search"
                            id="search_field"
                            name="search_field"
                            onChange={(e) => {
                                e.preventDefault();
                                handleFilterChange(e);
                            }}
                        />
                        <button
                            className="a-search-input__button"
                            type="submit"
                        >
                            <img
                                className="a-search-input__img"
                                src={searchIcon}
                                alt="search button icon"
                            />
                        </button>
                    </form>
                    <TabRow className="l-mt-sm l-mb-sm">
                        <TabRowItem 
                            tabTitle={<>
                                All Users{" "}
                                <span className="a-badge">{licensedUsers.length}</span>
                            </>}
                            tabId="all"
                            activeTab={mode === "all"}
                            helpText={`Users that currently have access to ${env.REACT_APP_BRANDING_SYMPHONY_NAME ?? "Maestro"}.`}
                            onTabChange={() => setMode("all")}
                        />
                        <TabRowItem 
                            tabTitle={<>
                                Users Needing Review{" "}
                                <span className="a-badge">{isLoadingUnusables ? "..." : unusableUsers.length}</span>
                            </>}
                            tabId="inactive"
                            activeTab={mode === "inactive"}
                            helpText="User accounts that need to be reviewed."
                            onTabChange={() => setMode("inactive")}
                        />
                    </TabRow>
                    <div className="o-block">
                        {displayedUsers.length === 0
                            ?   <div className="text-center" aria-colspan={4}>
                                    <p className="a-muted-text l-mt-xs">{`There are no users that currently ${mode === "all" ? "have licenses" : "need review"}.`}</p>
                                </div>
                            :   <Treegrid
                                    isCompact
                                    className="l-mr-sm"
                                    id="sharedUsers"
                                    columnSizes={["x-small", "small", "48"]}
                                >
                                    {displayedUsers.slice((currentPage - 1) * NUM_PER_PAGE, currentPage * NUM_PER_PAGE).map((user, index) => {
                                        // Creating a status message
                                        const status = isLoadingUnusables 
                                            ? "Loading..." 
                                            : unusableUsers?.find((u) => u.identifier === user.identifier)?.invalidReason ?? `Active`;

                                        return (
                                            <tr className="o-treegrid__row o-treegrid__row--shown" key={index}>
                                                <td className="o-treegrid__cell">
                                                    <span className="a-subtle-text">
                                                        <strong>
                                                            {user.givenName ?? user.identifier} {user.familyName}
                                                        </strong>
                                                    </span>
                                                </td>
                                                <td className="o-treegrid__cell o-treegrid__cell--right-aligned">
                                                    <span
                                                        className="a-subtle-text a-text--right-aligned"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (status === "User doesn't have access to the app registration") {
                                                                tryFixUser(user);
                                                            }
                                                        }}
                                                    >
                                                        {status}
                                                    </span>
                                                </td>
                                                <td className="o-treegrid__cell">
                                                    {isLicensedEnvironment &&
                                                        <Button 
                                                            className="a-button--full-width"
                                                            outline
                                                            size="small"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                deprovisionLicense(user.identifier);
                                                            }}
                                                            children="Remove"
                                                        />
                                                    }
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </Treegrid>
                            }
                        <Pagination 
                            data={displayedUsers}
                            numPerPage={NUM_PER_PAGE}
                            currentPage={currentPage}
                            onPageChange={(page) => setCurrentPage(page)}
                        />
                    </div>
                </div>
            </div>
            <AddUserModal
				isHidden={addUsersIsHidden}
				onClose={() => {
					setAddUsersIsHidden(true);
				}}
				availableLicenses={remainingLicenses}
			/>
        </>
    )
}

export default AccessControl;